import React from 'react';

import {
  MenuItemProps as AntdMenuItemProps,
} from 'antd';

import {
  StyledAntdMenuItem,
} from './style';

const MenuItem = ({
  children,
  ...props
}: AntdMenuItemProps): JSX.Element => (
  <StyledAntdMenuItem {...props}>{children}</StyledAntdMenuItem>
);

export default MenuItem;
